/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import InlineResponse2003 from '../model/InlineResponse2003';
import InlineResponse2004 from '../model/InlineResponse2004';
import InlineResponse2005 from '../model/InlineResponse2005';
import InlineResponse2006 from '../model/InlineResponse2006';
import InlineResponse422 from '../model/InlineResponse422';
import TokenGoalsBody from '../model/TokenGoalsBody';
import TokenVerifyBody from '../model/TokenVerifyBody';

/**
* Checkins service.
* @module api/CheckinsApi
* @version v0.3
*/
export default class CheckinsApi {

    /**
    * Constructs a new CheckinsApi.
    * @alias module:api/CheckinsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the getPatientGoalCheckinDetails operation.
     * @callback moduleapi/CheckinsApi~getPatientGoalCheckinDetailsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2004{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Read terms acceptance and activation status
     * @param {String} token Encrypted reminder token
     * @param {module:api/CheckinsApi~getPatientGoalCheckinDetailsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getPatientGoalCheckinDetails(token, callback) {

      let postBody = null;
      // verify the required parameter 'token' is set
      if (token === undefined || token === null) {
        throw new Error("Missing the required parameter 'token' when calling getPatientGoalCheckinDetails");
      }

      let pathParams = {
        'token': token
      };
      let queryParams = {

      };
      let headerParams = {

      };
      let formParams = {

      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InlineResponse2004;

      return this.apiClient.callApi(
        '/checkins/{token}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getPatientGoalCheckinGoals operation.
     * @callback moduleapi/CheckinsApi~getPatientGoalCheckinGoalsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2006{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Read the remaining goals for a verified check-in
     * @param {String} token
     * @param {String} sessionToken Session token returned by DOB verification
     * @param {module:api/CheckinsApi~getPatientGoalCheckinGoalsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getPatientGoalCheckinGoals(token, sessionToken, callback) {

      let postBody = null;
      // verify the required parameter 'token' is set
      if (token === undefined || token === null) {
        throw new Error("Missing the required parameter 'token' when calling getPatientGoalCheckinGoals");
      }
      // verify the required parameter 'sessionToken' is set
      if (sessionToken === undefined || sessionToken === null) {
        throw new Error("Missing the required parameter 'sessionToken' when calling getPatientGoalCheckinGoals");
      }

      let pathParams = {
        'token': token
      };
      let queryParams = {
        'session_token': sessionToken
      };
      let headerParams = {

      };
      let formParams = {

      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InlineResponse2006;

      return this.apiClient.callApi(
        '/checkins/{token}/goals', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the submitPatientGoalCheckinAnswers operation.
     * @callback moduleapi/CheckinsApi~submitPatientGoalCheckinAnswersCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2003{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Submit answers for a verified check-in
     * @param {module:model/TokenGoalsBody} body
     * @param {String} token
     * @param {module:api/CheckinsApi~submitPatientGoalCheckinAnswersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    submitPatientGoalCheckinAnswers(body, token, callback) {

      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling submitPatientGoalCheckinAnswers");
      }
      // verify the required parameter 'token' is set
      if (token === undefined || token === null) {
        throw new Error("Missing the required parameter 'token' when calling submitPatientGoalCheckinAnswers");
      }

      let pathParams = {
        'token': token
      };
      let queryParams = {

      };
      let headerParams = {

      };
      let formParams = {

      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = InlineResponse2003;

      return this.apiClient.callApi(
        '/checkins/{token}/goals', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the verifyPatientGoalCheckin operation.
     * @callback moduleapi/CheckinsApi~verifyPatientGoalCheckinCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2005{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Verify date of birth for a goal check-in
     * @param {module:model/TokenVerifyBody} body
     * @param {String} token Encrypted reminder token
     * @param {module:api/CheckinsApi~verifyPatientGoalCheckinCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    verifyPatientGoalCheckin(body, token, callback) {

      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling verifyPatientGoalCheckin");
      }
      // verify the required parameter 'token' is set
      if (token === undefined || token === null) {
        throw new Error("Missing the required parameter 'token' when calling verifyPatientGoalCheckin");
      }

      let pathParams = {
        'token': token
      };
      let queryParams = {

      };
      let headerParams = {

      };
      let formParams = {

      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = InlineResponse2005;

      return this.apiClient.callApi(
        '/checkins/{token}/verify', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}
